import './styles/index.css'
import 'typeface-roboto'

import React from 'react'
import { create } from 'jss'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import preset from 'jss-preset-default'
import mixpanel from 'mixpanel-browser'
import MixpanelProvider from 'react-mixpanel'
import { AppContainer } from 'react-hot-loader'
import JssProvider from 'react-jss/lib/JssProvider'
import { MuiThemeProvider } from '@material-ui/core/styles'
// import configureStore from 'store/configureStore'
import configureStore from 'store/configurePersistedStore'
import { PersistGate } from 'redux-persist/integration/react'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

import App from 'containers/core/App'
import theme from 'styles/theme'

// REDUX PERSIST - Add persist gate wrapper and import persistor
const { store, persistor } = configureStore()
// const store = configureStore()
const jss = create(preset())

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
  opt_out_tracking_by_default: false,
})
const distinctId = mixpanel.get_distinct_id()
mixpanel.identify(distinctId)
mixpanel.people.set({ name: distinctId })

/* eslint no-undef: 0 */
ReactDOM.render(
  <AppContainer>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <JssProvider jss={jss}>
          <MuiThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <MixpanelProvider mixpanel={mixpanel}>
                <App />
              </MixpanelProvider>
            </MuiPickersUtilsProvider>
          </MuiThemeProvider>
        </JssProvider>
      </PersistGate>
    </Provider>
  </AppContainer>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js